/*
 * @Author: zhaoyu zhaoyu@belink.com
 * @Date: 2022-08-24 14:12:06
 * @LastEditors: caoshuai 63615488@qq.com
 * @LastEditTime: 2022-11-12 23:09:32
 * @FilePath: /pscd-portal-new-workbench/packages/www/plugins/prototype.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { AjaxBasics } from '@mamba/clients';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import weekday from 'dayjs/plugin/weekday';
import lodash from 'lodash';
import queryString from 'query-string';
import Vue from 'vue';
import VueClipBoard from 'vue-clipboard2';
import { link } from './extension';
import { $AppConfig } from './global';
import { Static } from './static';
import { Store } from './store';
dayjs.locale('zh-cn');
dayjs.extend(weekday);
dayjs.extend(duration);
Vue.use(VueClipBoard);
lodash.set(Vue, '$onLoginOut', async () => {
    await $AppConfig.onClear();
    await Store.System.onLoginOut();
    window.location.href = window.location.origin;
});
Object.defineProperty(Vue.prototype, '$onLoginOut', {
    get: lodash.constant(Vue.$onLoginOut),
});
/**
 * 检查用户 状态 已登录返回用户信息
 * @navigateTo
 */
Object.defineProperty(Vue.prototype, '$InspectUser', {
    get: lodash.constant(function (navigateTo = true, redirectUrl) {
        const System = Store.System;
        try {
            return System.onInspectUser();
        }
        catch (error) {
            const defaultRedirect = window.location;
            if (navigateTo) {
                let url = queryString.stringifyUrl({
                    url: link.account,
                    query: {
                        appId: 'ex55ohg9qfe6feuw',
                        scope: 'basic',
                        display: 'none',
                        forceLogin: 'false',
                    },
                });
                url += `&redirectUrl=${encodeURIComponent(redirectUrl ? redirectUrl : defaultRedirect)}`;
                window.location.href = url;
            }
            throw error;
        }
    }),
});
Object.defineProperty(Vue.prototype, '$Static', {
    get: lodash.constant(Static),
});
// 创建 页面地址 转换参数
Object.defineProperty(Vue.prototype, '$CreatePageUrl', {
    get: lodash.constant((url, query) => {
        url = AjaxBasics.queryParamsToUrl(url, query);
        url = queryString.stringifyUrl({
            url,
            query: lodash.pickBy(query, lodash.identity),
        });
        return url;
    }),
});
// 页面跳转
Object.defineProperty(Vue.prototype, '$windowOpen', {
    get: lodash.constant((url) => {
        if ($AppConfig.userAgent.isiOS) {
            location.href = url;
        }
        else {
            window.open(url);
        }
    }),
});
// 切换身份
Object.defineProperty(Vue.prototype, '$ChangeIdentity', {
    get: lodash.constant((redirectUrl, identityId) => {
        const url = queryString.stringifyUrl({
            url: `${$AppConfig.target}/account/function/changeuser/?change=true`,
            query: { redirectUrl, identityId },
        });
        window.location.href = url;
    }),
});
// 外链
Object.defineProperty(Vue.prototype, '$Link', {
    get: () => link,
});
